var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.375 6.375C41.5022 6.375 42.5832 6.82277 43.3802 7.6198C44.1772 8.41683 44.625 9.49783 44.625 10.625V40.375C44.625 41.5022 44.1772 42.5832 43.3802 43.3802C42.5832 44.1772 41.5022 44.625 40.375 44.625H10.625C9.49783 44.625 8.41683 44.1772 7.6198 43.3802C6.82277 42.5832 6.375 41.5022 6.375 40.375V10.625C6.375 9.49783 6.82277 8.41683 7.6198 7.6198C8.41683 6.82277 9.49783 6.375 10.625 6.375H40.375ZM39.3125 39.3125V28.05C39.3125 26.2127 38.5826 24.4507 37.2835 23.1515C35.9843 21.8524 34.2223 21.1225 32.385 21.1225C30.5787 21.1225 28.475 22.2275 27.455 23.885V21.5263H21.5263V39.3125H27.455V28.8362C27.455 27.2 28.7725 25.8613 30.4088 25.8613C31.1978 25.8613 31.9545 26.1747 32.5124 26.7326C33.0703 27.2905 33.3838 28.0472 33.3838 28.8362V39.3125H39.3125ZM14.62 18.19C15.5668 18.19 16.4749 17.8139 17.1444 17.1444C17.8139 16.4749 18.19 15.5668 18.19 14.62C18.19 12.6438 16.5963 11.0288 14.62 11.0288C13.6675 11.0288 12.7541 11.4071 12.0806 12.0806C11.4071 12.7541 11.0288 13.6675 11.0288 14.62C11.0288 16.5963 12.6438 18.19 14.62 18.19ZM17.5738 39.3125V21.5263H11.6875V39.3125H17.5738Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.60219700fe4f370d36ac49e3b6033b2b.svg";
export { ForwardRef as ReactComponent };